import { createContext, Dispatch, SetStateAction } from "react";

export interface StatefulTabsContextI<T> {
    state: T;
    setState: Dispatch<SetStateAction<T>>;
    activeTab: number;
    setActiveTab: (currentTab: number) => unknown;
}

export const StatefulTabsContext = createContext<StatefulTabsContextI<unknown>>({
    state: undefined,
    setState: () => undefined,
    activeTab: 0,
    setActiveTab: () => undefined,
});

export const StatefulTabsProvider = StatefulTabsContext.Provider;
export const StatefulTabsConsumer = StatefulTabsContext.Consumer;
